import { TopBar } from '@/common/components/TopBar/TopBar';
import { useRouter } from 'expo-router';

export function TabsTopBar() {
  const router = useRouter();

  const handleBack = () => {
    if (router.canDismiss()) {
      router.dismiss();
    } else {
      router.back();
    }
  };

  return <TopBar onBack={router.canDismiss() ? handleBack : undefined} />;
}
